<template>
  <main class="relative z-30 flex items-center justify-center">
    <div class="container text-center px-4">
      <div class="bg-transparent  max-w-2xl mx-auto">
        <img 
          src="@/assets/images/plane-min.png" 
          alt="Avion" 
          class="w-32 h-32 mx-auto mb-6 animate-pulse"
        />
        
        <h1 class="text-4xl sm:text-5xl font-bold text-blue-900 mb-4">
          {{ $t("gameover.title") }}
        </h1>
        
        <p class="text-xl sm:text-2xl text-gray-700 mb-8">
          {{ $t("gameover.subtitle") }}
        </p>
        
        <div class="bg-blue-50 rounded-xl p-6 mb-8">
          <p class="text-lg text-gray-600 mb-4">
            {{ $t("gameover.thanksMessage") }}
          </p>
          <p class="text-md text-gray-500">
            {{ $t("gameover.comeBackMessage") }}
          </p>
        </div>
        

        

      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "GameOverView",
  mounted() {
    sessionStorage.removeItem("lot");
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("gameStarted");
    
    console.log("Jeu terminé - Session nettoyée");
  }
};
</script>

<style scoped>
.cta-button {
  @apply px-8 py-3 bg-blue-600 text-white rounded-full font-semibold hover:bg-blue-700 transition-colors;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>